import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const Navigation = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: "/", label: "Home", testId: "nav-home" },
    { path: "/services", label: "Services", testId: "nav-services" },
    { path: "/consultation", label: "Consultation", testId: "nav-consultation" },
    { path: "/production", label: "Production", testId: "nav-production" },
    { path: "/portfolio", label: "Portfolio", testId: "nav-portfolio" },
  ];
  
  return (
    <nav className="fixed top-4 left-4 right-4 glass rounded-full shadow-lg z-50 px-4 md:px-8 py-4" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img src="/logo.jpg" alt="The Lux Standard" className="h-10 md:h-12 w-auto" />
        </Link>
        
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={link.testId}
              className={`text-sm font-medium transition-colors hover:text-[#D4AF37] ${
                isActive(link.path) ? "text-[#D4AF37]" : "text-[#1A1A1A]"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/inquiry"
            data-testid="nav-inquiry-button"
            className="bg-[#D4AF37] text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-[#b89530] transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Book Consultation
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <div className="flex md:hidden items-center gap-3">
          <Link
            to="/inquiry"
            className="bg-[#D4AF37] text-white px-4 py-2 rounded-full text-xs font-medium hover:bg-[#b89530] transition-all"
          >
            Book Now
          </Link>
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 text-[#1A1A1A] hover:text-[#D4AF37] transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 mt-2 mx-4 bg-white rounded-2xl shadow-xl border border-[#F2EBE5] overflow-hidden">
          <div className="py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-${link.testId}`}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-6 py-3 text-base font-medium transition-colors hover:bg-[#F9F8F6] ${
                  isActive(link.path) ? "text-[#D4AF37] bg-[#F9F8F6]" : "text-[#1A1A1A]"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-6 pt-3 pb-2">
              <Link
                to="/inquiry"
                onClick={() => setMobileMenuOpen(false)}
                className="block w-full text-center bg-[#D4AF37] text-white px-6 py-3 rounded-full text-base font-medium hover:bg-[#b89530] transition-all"
              >
                Book Consultation
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;